import React from 'react';
import PropTypes from 'prop-types';

import { Route, Switch } from 'react-router-dom';
import Template from '../../components/template/template';

import TemplateList from './templateList';
import PageError from '../error/pageError';

export default function MailRouter({ organization, path }) {
    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={basenameProps => (
                    <Template organization={organization}>
                        <TemplateList organization={organization} />
                    </Template>
                )}
            />

            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

MailRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
